import { registerLocaleData } from '@angular/common';
import localeSv from '@angular/common/locales/sv';
import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthInternalService } from '@vinnova/auth-internal';
import { TranslateService } from '@vinnova/translation';

registerLocaleData(localeSv);

@UntilDestroy()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    private authInternalService: AuthInternalService,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.authInternalService
      .awaitLoginAndInitAccount()
      .pipe(untilDestroyed(this))
      .subscribe();
    this.translateService
      .setActiveLang()
      .pipe(untilDestroyed(this))
      .subscribe();
  }
}
